export const EXTERNAL_USER = 'externaluser';
export const SET_EXTERNAL_USERS = `${EXTERNAL_USER}/setExternalUserAction`;
export const GET_EXTERNAL_USERS = `${EXTERNAL_USER}/getExternalUserAction`;
export const SET_CONSENT = `${EXTERNAL_USER}/setConsentAction`;
export const GET_CONSENT = `${EXTERNAL_USER}/getConsentAction`;
export const SET_IMAGE = `${EXTERNAL_USER}/setUserImageAction`;
export const GET_EVALUATION = `${EXTERNAL_USER}/getUserEvaluationAction`;

export const GET_ASSESSMENT = `${EXTERNAL_USER}/getUserAssessmentAction`;



export const SET_QUESTION = `${EXTERNAL_USER}/setQuestionAction`;

// For saving Assessment Response for external user
export const SAVE_ASSESSMENT_RESPONSE_EXTERNAL = `${EXTERNAL_USER}/saveExternalAssessmentResponseAction`;
// export const SET_ASSESSMENT = `${EXTERNAL_USER}/setUserAssessmentAction`;

// For saving Assessment Response for internal user
export const SAVE_ASSESSMENT_RESPONSE_INTERNAL = `${EXTERNAL_USER}/saveInternalAssessmentResponseAction`;

// export const GET_ATTENDED_QUESTION_COUNT = `${EXTERNAL_USER}/getAttendedQuestionCountAction`;

export const SAVE_INTERNAL_QUESTION = `${EXTERNAL_USER}/saveInternalQuestionAction`;
export const SAVE_EXTERNAL_QUESTION = `${EXTERNAL_USER}/saveExternalQuestionAction`;
export const SAVE_EXTERNAL_USER_DEVICE_DETAILS = `${EXTERNAL_USER}/saveExternalUserDeviceDetail`;
export const SAVE_IMAGES_FROM_SKILL_INSIGHT_APP = `${EXTERNAL_USER}/saveImagesFromSkillInsightApp`;
export const SET_EXTERNAL_IMAGE_STORE = `${EXTERNAL_USER}/setExternalImageStore`;
export const GET_EXTERNAL_USER_ENCRYPTED_EMAIL = `${EXTERNAL_USER}/getExternalUserEncryptedEmail`;
export const SEND_MAIL_FOR_HR = `${EXTERNAL_USER}/sendMailForHRAction`;
